/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateScopeOfCareDto } from '../../models/create-scope-of-care-dto';
import { ScopeOfCareDto } from '../../models/scope-of-care-dto';

export interface CreateScopeOfCare$Params {

/**
 * The customer id
 */
  customerId: number;
      body: CreateScopeOfCareDto
}

export function createScopeOfCare(http: HttpClient, rootUrl: string, params: CreateScopeOfCare$Params, context?: HttpContext): Observable<StrictHttpResponse<ScopeOfCareDto>> {
  const rb = new RequestBuilder(rootUrl, createScopeOfCare.PATH, 'post');
  if (params) {
    rb.query('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScopeOfCareDto>;
    })
  );
}

createScopeOfCare.PATH = '/scopes-of-care';
